export enum PAYMENT_SLIP_FILTERED_FIELD_OPTIONS_ENUM {
  ORDER_NUMBER = 'orderNumber',
  FINAL_CUSTOMER_DOCUMENT = 'finalCustomerDocument',
  INVOICE_NUMBER = 'invoiceNumber',
}

export enum PAYMENT_SLIP_PRODUCT_TYPE_ENUM {
  HARDWARE = 1,
  SOFTWARE_SERVICE_CLOUD = 2,
}
